import { useState } from "react";
import TinyMessageEditorView from "./TinyMessageEditorView";
import useCustomEffect from "../../../hooks/useCustomEffect";
import useEvaApi, { EvaApiCall } from "../../../hooks/useEvaApi";
import { useAuthContext } from "../../../context/AuthContext";

function TinyMessageEditor({ controller }) {
  const authContext = useAuthContext();
  const callEvaApi = useEvaApi();
  const [editorHeight, setEditorHeight] = useState(null);
  const [fields, setFields] = useState([]);

  //Define the available tags
  let tags = [
    "vis_company_name",
    "vis_location_name",
    "vis_location_address",
    "vis_visitor_type_name",
    "vis_language_label",
    "vis_sign_in_terminal_name",
    "vis_employee_title",
    "vis_employee_name",
    "vis_employee_first_name",
    "vis_employee_last_name",
    "vis_email",
    "vis_registration_code",
    "vis_registration_code_qr",
    "vis_returning",
    "vis_expected_date",
    "vis_expected_end_date",
    "vis_expected_time",
    "vis_signed_in_at",
    "vis_signed_out_at",
    "vis_status",
    "vis_approval_status",
    "vis_approval_link",
    "vis_portal_link",
    "vis_license_plate",

    ...fields.map((field) => `field_${field.key}`),
  ];

  if (authContext.auth?.user?.company?.salto_config) {
    tags.push("vis_salto_user_pin");
  }

  if (authContext.auth?.user?.company?.access_commander_config) {
    tags.push("vis_access_commander_2n_pin");
    tags.push("vis_access_commander_2n_pin_qr");
  }

  tags = tags.sort();

  /**
   * UseEffect to fetch the fields from the API
   */
  useCustomEffect(() => {
    fetchFields();
  });

  /**
   * UseEffect for updating the editor height when the editor is resized
   */
  useCustomEffect(() => {
    if (controller.initialized) {
      setEditorHeight(
        controller.editorRef.current.editorContainer?.offsetHeight,
      );

      controller.editorRef.current.on("ResizeEditor", (e) => {
        setEditorHeight(e.target.container.offsetHeight);
      });

      return () => {
        controller.editorRef.current.off("ResizeEditor");
      };
    }
  }, [controller.initialized]);

  /**
   * This message will fetch the fields from the API
   */
  async function fetchFields() {
    await callEvaApi(
      new EvaApiCall("fields")
        .setLoadingGroup("tiny_message_editor_fetch")
        .setOnSuccess((response) => {
          setFields(response.data.data.records);
        }),
    );
  }

  /**
   * This method will handle the tag click
   * @param {String} tag
   */
  function onTagClick(tag) {
    if (tag && controller.initialized) {
      controller.insertAtCursor(`[${tag}]`);
    }
  }

  return (
    <TinyMessageEditorView
      controller={controller}
      tags={tags}
      onTagClick={onTagClick}
      editorHeight={editorHeight}
    />
  );
}

export default TinyMessageEditor;
